// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutConsole from '@layouts/LayoutConsole';

// Pages
import PageSettings from '@pages/settings';
import PageSettingsIntegrations from '@pages/settings-integrations/index';

// Integrations
import PageSettingsIntegrationsEdit from '@pages/settings-integrations/PageSettingsIntegrationsEdit';
import PageSettingsIntegrationsShoutOut from '@pages/settings-integrations/PageSettingsIntegrationsShoutOut';
import PageSettingsIntegrationsTwilio from '@pages/settings-integrations/PageSettingsIntegrationsTwilio';

export default {
    path: '/settings',
    component: LayoutConsole,
    meta: {
        middleware: [
            AuthMiddleware,
        ],
    },
    children: [
        {
            path: '',
            component: PageSettings,
            children: [
                {
                    path: 'integrations',
                    name: 'settings-integrations',
                    component: PageSettingsIntegrations,
                    meta: {
                        title: 'Settings | Integrations',
                    },
                },
                {
                    path: 'integrations/shoutout',
                    name: 'settings-integrations-shoutout',
                    component: PageSettingsIntegrationsShoutOut,
                    meta: {
                        title: 'Settings | Integrations',
                    },
                },
                {
                    path: 'integrations/twilio',
                    name: 'settings-integrations-twilio',
                    component: PageSettingsIntegrationsTwilio,
                    meta: {
                        title: 'Settings | Integrations',
                    },
                },
                {
                    path: 'integrations/:slug/:callback?',
                    name: 'settings-integrations-edit',
                    component: PageSettingsIntegrationsEdit,
                    meta: {
                        title: 'Settings | Integrations',
                    },
                },
            ],
        },
    ]
}